import { render } from "./ModuleHomeSections.vue?vue&type=template&id=0991b776&scoped=true&ts=true&lang=pug"
import script from "./ModuleHomeSections.vue?vue&type=script&lang=ts"
export * from "./ModuleHomeSections.vue?vue&type=script&lang=ts"

import "./ModuleHomeSections.vue?vue&type=style&index=0&id=0991b776&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0991b776"]])

export default __exports__